import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import wrap from '../../util/wrap_with_intl_provider';
import Table from '../../../../../components/Table';
import ax from '../../util/axios';
import {
  admin_area_scenario_observation_events_path,
  organisation_area_scenario_observation_events_path,
} from '../../../../../routes';
import StatusLabel from '../../../../../components/StatusLabel';

const ScenarioObservationEvents = (props) => {
  const intl = useIntl();

  const [pagination, setPagination] = useState({});
  const [items, setItems] = useState([]);

  const fetchItems = async (page = 1) => {
    const loadUrl = props.isAdmin
      ? admin_area_scenario_observation_events_path
      : organisation_area_scenario_observation_events_path;
    const response = await ax.get(loadUrl(props.id, { format: 'json', page }));
    setPagination(response.data.pagination);
    setItems(response.data.items);
  };

  const itemsColumns = [
    {
      accessor: 'eventId',
      header: intl.formatMessage({ id: 'admin-area.settings.observation-event.fields.event-id' }),
    },
    {
      accessor: 'description',
      header: intl.formatMessage({ id: 'admin-area.settings.observation-event.fields.description' }),
    },
    {
      accessor: 'status',
      header: intl.formatMessage({ id: 'admin-area.settings.incident.fields.status' }),
    },
    {
      accessor: 'deviceType',
      header: intl.formatMessage({ id: 'admin-area.settings.micro-event.fields.device-type' }),
    },
  ];

  useEffect(() => {
    fetchItems();
  }, []);

  const mappedItems = items.map((event) => ({
    ...event,
    deviceType: event.deviceType ? intl.formatMessage({ id: `units.unit-type.${event.deviceType}` }) : '',
    status: <StatusLabel text={event.status} status={event.status === 'active' ? 'passed' : 'failed'} />,
  }));

  if (pagination.total != undefined) {
    return <Table items={mappedItems} columns={itemsColumns} pagination={pagination} onPageChange={fetchItems} />;
  }
};

ScenarioObservationEvents.propTypes = {
  id: PropTypes.number.isRequired,
  isAdmin: PropTypes.bool,
};

export default wrap(ScenarioObservationEvents);
